import React, { useState } from "react";
import {
  Dialog,
  makeStyles,
  useMediaQuery,
  useTheme,
  CircularProgress,
} from "@material-ui/core";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import axios from "axios";
import { CreateBankAPI } from "../../config/api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { FilePicker } from "../../components/common/FilePicker.js";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    fontSize: "14px",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
  },
};

const useStyles = makeStyles(styles);

export default function BankAdd(props) {
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  const authToken = useSelector((state) => state.userReducer.authToken);
  const classes = useStyles();
  const theme = useTheme();
  const { open, close, fetchData } = props;
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  const [bankName, setBankName] = useState("");
  const [acNo, setAcNo] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [branch, setBranch] = useState("");
  const [qrCode, setQrCode] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function _onSave() {
    if (!bankName || !acNo || !ifscCode || !branch) {
      toast.error("Please fill all the fields", { position: "top-center" });
      return;
    }

    const formData = new FormData();
    formData.append("bankName", bankName.trim());
    formData.append("acNo", acNo.trim());
    formData.append("ifscCode", ifscCode.trim().toUpperCase());
    formData.append("branch", branch.trim());
    formData.append("entity", userInfo.entity);

    if (qrCode.length > 0 && qrCode[0].path) {
      formData.append("qrCode", qrCode[0].path);
    }

    setIsSubmitting(true);
    try {
      await axios.post(CreateBankAPI(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      });

      toast.success("Successfully Added!", { position: "top-center" });
      close();

      // Reset form
      setBankName("");
      setAcNo("");
      setIfscCode("");
      setBranch("");
      setQrCode([]);

      // Refresh data
      if (fetchData && typeof fetchData === 'function') {
        fetchData();
      }
    } catch (e) {
      toast.error("Something went wrong, please contact admin", {
        position: "top-center",
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={close}
      aria-labelledby="responsive-dialog-title"
    >
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Add Bank Master</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {/* QR Code Upload */}
                <GridItem xs={12}>
                  <FilePicker
                    files={qrCode}
                    buttonLabel={"Upload Bank QR Code"}
                    id={"Bank QR Code"}
                    maxFiles={1}
                    setNewFiles={setQrCode}
                    filetype={".png,.jpg,.jpeg"}
                  />
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Bank Name*"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      value: bankName,
                      onChange: (e) => setBankName(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Ac No*"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      value: acNo,
                      onChange: (e) => setAcNo(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="IFSC Code*"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      value: ifscCode,
                      onChange: (e) => setIfscCode(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Branch*"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      value: branch,
                      onChange: (e) => setBranch(e.target.value),
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter style={{ justifyContent: "center" }}>
              <Button
                color="primary"
                onClick={_onSave}
                disabled={isSubmitting}
              >
                {isSubmitting ? <CircularProgress size={24} /> : "Add Bank Master"}
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}
